<template>
  <div class="agency-left">
    <title-one :title="`机构列表`" />
    <div class="rank-one left">
      <el-button icon="el-icon-plus" class="add-btn" plain size="mini" @click.stop="addFn" />
      <div class="agency-list-warp">
        <agency-item
          v-for="(item, index) in agencyList"
          :key="index"
          class="agency-item-warp"
          :class="{'active-item': activeIndex === index}"
          :init-item="item"
          @select="selectFn"
          @fix="fixFn"
          @delete="deleteFn"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TitleOne from '@/components/TitleOne/TitleOne'
import AgencyItem from '@/views/Setting/components/AgencyItem'
import { deepCopy } from '@/utils/tool'
import { mapState } from 'vuex'
export default {
  name: 'AgencyLeft',
  components: { AgencyItem, TitleOne },
  data() {
    return {
      newAgency: {
        'name': '新增企业',
        'size': 1,
        'x': 0,
        'y': 0,
        'energyUseStatistics': [178, 70, 30, 50, 12],
        'energyProportionLegend': ['电力', '天然气', '煤炭', '其他'],
        'energyProportion': [70, 30, 12, 3],
        'unitOutputDate': [2018, 2019, 2020],
        'unitOutputNum': [105, 12, 30],
        'unitProductDate': [2018, 2019, 2020],
        'unitProductNum': [60, 12, 20]
      },
      agencyList: [],
      activeIndex: 0
    }
  },
  computed: {
    ...mapState({
      'initAgencyList': 'agencyList'
    })
  },
  watch: {
    initAgencyList: {
      handler(newV, oldV) {
        this.agencyList = deepCopy({ value: newV }).value.map((item, index) => ({ ...item, index }))
        this.activeIndex = 0
        this.$store.commit('changeCurAgency', this.agencyList[0])
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.activeIndex = 0
    this.$store.commit('changeCurAgency', this.agencyList[0])
  },
  methods: {
    selectFn(value) {
      if (this.activeIndex !== value.index) {
        this.activeIndex = value.index
        this.$store.commit('changeCurAgency', value)
      }
    },
    addFn() {
      this.agencyList.unshift(deepCopy(this.newAgency))
      this.agencyList = this.agencyList.map((item, index) => ({ ...item, index }))
      this.activeIndex = 0
      this.$store.commit('changeCurAgency', this.agencyList[0])
    },
    fixFn(val) {
      this.agencyList.splice(val.index, 1, val)
      this.$store.commit('changeCurAgency', val)
    },
    deleteFn(val) {
      this.agencyList.splice(val.index, 1)
      this.agencyList = this.agencyList.map((item, index) => ({ ...item, index }))
      if (this.agencyList.length) {
        if (val.index === this.agencyList.length) {
          this.$store.commit('changeCurAgency', this.agencyList[val.index - 1])
        } else {
          this.$store.commit('changeCurAgency', this.agencyList[val.index])
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .rank-one {
    width: 100%;
    height: 1213px;
    padding: 40px 20px 20px;
    background: url("../../Home/images/right-1.png") top left no-repeat;
    background-size: 100% 100%;
    position: relative;
    .add-btn{
      position: absolute;
      top: 8px;
      right: 6px;
      background: transparent;
      color: #fff;
      padding: 4px 7px;
      border: none;
    }
    .agency-list-warp{
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      &::-webkit-scrollbar {
        display: none;
      }
      .agency-item-warp{
        padding: 10px 4px 16px;
        margin-bottom: 6px;
        &:not(:last-child){
          border-bottom: 1px dashed rgba(123, 123, 123, 0.4);
        }
      }
      .active-item{
        border-radius: 6px;
        background: rgba(53, 232, 206, 0.1);
      }
    }
  }
  .m-top{
    margin-top: 16px;
  }
  .left{
    position: relative;
    top: -6px;
  }
</style>
